var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJoblistActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.99353H4C2.89543 6.99353 2 7.88896 2 8.99353V18.9935C2 20.0981 2.89543 20.9935 4 20.9935H20C21.1046 20.9935 22 20.0981 22 18.9935V8.99353C22 7.88896 21.1046 6.99353 20 6.99353Z",
    stroke: "#0D062D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20.9935V4.99353C16 4.4631 15.7893 3.95439 15.4142 3.57932C15.0391 3.20424 14.5304 2.99353 14 2.99353H10C9.46957 2.99353 8.96086 3.20424 8.58579 3.57932C8.21071 3.95439 8 4.4631 8 4.99353V20.9935",
    stroke: "#0D062D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoblistActive);
export default __webpack_public_path__ + "static/media/joblist-active.0723bc338ecb53efd9458123b01b9eff.svg";
export { ForwardRef as ReactComponent };